import React, { PureComponent } from 'react'
import { injectIntl, FormattedHTMLMessage } from 'react-intl'

import { scrollTo } from './services/utils'

import Level from './Level'
import Loader from './Loader'
import Error from './Error'

import { StarIcon } from './Icons'

import './Levels.css'

export default injectIntl(
  class Levels extends PureComponent {
    componentDidUpdate(prevProps) {
      const { levels } = this.props
      if (levels !== prevProps.levels) {
        scrollTo(this.element)
      }
    }
    renderLevels() {
      const { levels, level, technicalError, onChanged } = this.props

      if (levels === undefined && !technicalError) {
        return <Loader loading={true} />
      }

      if (levels !== undefined && levels.length > 0) {
        return levels.map(l => (
          <Level
            name={l.name}
            normalizedCode={l.normalizedCode}
            code={l.code}
            key={l.id}
            image={l.image}
            comment={l.comment}
            onChanged={onChanged}
            selected={level === l.code}
          />
        ))
      }

      return <Error technicalError={technicalError} kind="levels" />
    }

    render() {
      return (
        <div ref={el => (this.element = el)} className="cm-levels">
          <div className="cm-levels--title">
            <StarIcon className="cm-levels--picto" />
            <FormattedHTMLMessage id="levels_objectives" />
          </div>
          <div className="cm-levels--outer">{this.renderLevels()}</div>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/Levels.js